<template>
  <shipblu-prompt
    class="shipment-modal"
    @close="closeModal"
    :active.sync="addUserModal"
    :title="type === 'add' ? `${$t('Add Merchant Account')}`: `${$t('Edit Merchant Account')}`"
    :buttons-hidden="true">
      <div class="grid grid-cols-2 gap-x-6 mb-2">
        <div class="sm:col-span-1 col-span-2">
          <vs-input v-validate="'required|alpha'" :label-placeholder="$t('First Name')" name="first name" v-model="data.first_name" class="mt-10 w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('first name')">{{ errors.first('first name') }}</span>
        </div>
        <div class="sm:col-span-1 col-span-2">
          <vs-input v-validate="'required|alpha'" :label-placeholder="$t('Last Name')" name="last name" v-model="data.last_name" class="mt-10 w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('last name')">{{ errors.first('last name') }}</span>
        </div>
        <div class="sm:col-span-1 col-span-2">
          <vx-input-group class="w-full flex items-stretch">
            <vs-input :disabled="type === 'edit'" v-validate="type === 'add' && ($store.state.AppActiveUser.userRole === 'merchant' ? 'required|email' : { required: true, regex: /^[^@\s]+$/ })" name="email" :label-placeholder="$t('Email')" v-model="email" class="mt-10"/>
            <template v-if="type !== 'edit' && $store.state.AppActiveUser.userRole !== 'merchant'" #append>
              <span class="append-text mt-10 bg-[#F1F3F6] text-[#00000099] border border-solid border-l-0 border-[#00000033] px-[9px]">@shipblu.com</span>
            </template>
          </vx-input-group>
          <span class="text-danger text-sm" v-show="errors.has('email')">{{ errors.first('email') }}</span>
        </div>
        <div class="sm:col-span-1 col-span-2">
          <vs-input v-validate="{ required: true, regex: /(^01[0,1,2,5]\d{8}$|^\u0660\u0661[\u0660,\u0661,\u0662,\u0665][\u0660-\u0669]{8}$)/ }" name="phone nmber" :label-placeholder="$t('Phone Number')" v-model="data.phone_number" class="mt-10 w-full"/>
          <span class="text-danger text-sm" v-show="errors.has('phone nmber')">{{ errors.first('phone nmber') }}</span>
        </div>
        <template v-if="type === 'add'">
          <div class="sm:col-span-1 col-span-2">
            <vs-input ref="password" type="password" v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[0-9a-zA-Z!@#$%^&*]{8,}$/ }" :label-placeholder="$t('Password')" name="password" v-model="data.password" class="mt-10 w-full" />
            <span class="text-danger text-sm" v-show="errors.has('password')">{{ errors.first('password') }}</span>
          </div>
          <div class="sm:col-span-1 col-span-2">
            <vs-input type="password" v-validate="{ required: true, confirmed:'password' ,regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[0-9a-zA-Z!@#$%^&*]{8,}$/ }" :label-placeholder="$t('Confirm Password')" name="confirm password" v-model="data.confirm_password" class="mt-10 w-full" data-vv-as="password" />
            <span class="text-danger text-sm" v-show="errors.has('confirm password')">{{ errors.first('confirm password') }}</span>
          </div>
        </template>

        <!-- Permissions -->
        <div class="mt-6 col-span-2">
          <div class="border border-solid border-[#00000033] rounded-md">
            <div class="sm:flex hidden items-center border-0 border-b border-solid border-[#00000033] py-3 px-1">
              <p class="flex-shrink-0 w-1/5 px-1"></p>
              <p class="flex-shrink-0 w-2/5 px-1">{{ $t('Base') }}</p>
              <p class="flex-shrink-0 w-2/5 px-1">{{ $t('Cash Amount') }}</p>
            </div>

            <div class="flex sm:flex-row flex-col sm:gap-0 gap-2 sm:items-center py-2 px-1 border-0 border-b border-solid border-[#00000033]">
              <p class="flex-shrink-0 sm:w-1/5 px-1">{{ $t('Delivery Orders:') }}</p>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.delivery_orders.base" :reduce="option => option.value" class="w-full" name="delivery-orders" :placeholder="$t('Base')" label="name" :options="permissionsOptions" />
              </div>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.delivery_orders.cash_amount" :reduce="option => option.value" class="w-full" name="delivery-orders" :placeholder="$t('Cash Amount')" label="name" :options="permissionsOptions" />
              </div>
            </div>

            <div class="flex sm:flex-row flex-col sm:gap-0 gap-2 sm:items-center py-2 px-1 border-0 border-b border-solid border-[#00000033]">
              <p class="flex-shrink-0 sm:w-1/5 px-1">{{ $t('Return Orders:') }}</p>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.return_orders.base" :reduce="option => option.value" class="w-full" name="return-orders" :placeholder="$t('Base')" label="name" :options="permissionsOptions" />
              </div>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.return_orders.cash_amount" :reduce="option => option.value" class="w-full" name="return-orders" :placeholder="$t('Cash Amount')" label="name" :options="permissionsOptions" />
              </div>
            </div>

            <div class="flex sm:flex-row flex-col sm:gap-0 gap-2 sm:items-center py-2 px-1 border-0 border-b border-solid border-[#00000033]">
              <p class="flex-shrink-0 sm:w-1/5 px-1">{{ $t('Financials:') }}</p>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.financials.base" :reduce="option => option.value" class="w-full" name="financials" :placeholder="$t('Base')" label="name" :options="permissionsOptions" />
              </div>
            </div>

            <div class="flex sm:flex-row flex-col sm:gap-0 gap-2 sm:items-center py-2 px-1 border-0 border-b border-solid border-[#00000033]">
              <p class="flex-shrink-0 sm:w-1/5 px-1">{{ $t('Payout Accounuts:') }}</p>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.payout_methods.base" :reduce="option => option.value" class="w-full" name="payout-methods" :placeholder="$t('Base')" label="name" :options="permissionsOptions" />
              </div>
            </div>

            <div class="flex sm:flex-row flex-col sm:gap-0 gap-2 sm:items-center py-2 px-1">
              <p class="flex-shrink-0 sm:w-1/5 px-1">{{ $t('Users:') }}</p>
              <div class="flex-shrink-0 sm:w-2/5 px-1">
                <v-select autocomplete="nofill" multiple v-model="permissions.users.base" :reduce="option => option.value" class="w-full" name="users" :placeholder="$t('Base')" label="name" :options="permissionsOptions" />
              </div>
            </div>
          </div>
        </div>
        
        <div class="col-span-2">
          <vs-checkbox class="mt-10 w-full mb-2" name="access financials" v-model="data.access_financials">{{ $t('Access Financials') }}</vs-checkbox>
          <span class="m-1">({{ $t('Account will have access to the financials tab') }})</span>
          <span class="text-danger text-sm" v-show="errors.has('access financials')">{{ errors.first('access financials') }}</span>
        </div>
        <div class="col-span-2" v-if="data.access_financials == true">
          <vs-checkbox class="mt-10 w-full mb-2" name="access payout methods" v-model="data.access_payout_methods">{{ $t('Access Payout Methods') }}</vs-checkbox>
          <span class="m-1">({{ $t('Account will have access to add or change payout methods') }})</span>
          <span class="text-danger text-sm" v-show="errors.has('access payout methods')">{{ errors.first('access payout methods') }}</span>
        </div>
      </div>
      <div class="grid grid-cols-2 gap-4 mt-4">
        <button @click="closeModal" class="btn disable-btn">{{ $t('Cancel') }}</button>
        <button v-if="type === 'add'" @click="addUser" class="active-btn btn">{{ $t('Add') }}</button>
        <button v-else @click="updateUser" class="active-btn btn">{{ $t('Save') }}</button>
      </div>
  </shipblu-prompt>
</template>

<script>
import ShipbluPrompt from '../../../layouts/components/ShipBluPrompt.vue'
import {sendRequest} from '../../../http/axios/requestHelper.js'
import vSelect from 'vue-select'
import i18nData from '../../../i18n/i18nData.js'

export default {
  props: ['warehouses', 'warehousesDic', 'addUserModal', 'type', 'data', 'merchantId'],
  data () {
    return {
      apiURL: 'api/v1/users/merchants/',
      editMode: true,
      email: '',
      user: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        confirm_password: ''
      },
      permissions: {
        delivery_orders: { base: [], cash_amount: [] },
        return_orders: { base: [], cash_amount: [] },
        financials: { base: [] },
        payout_methods: { base: [] },
        users: { base: [] }
      },
      permissionsOptions: [
        { name: 'View', value: 'view' },
        { name: 'Create', value: 'create' },
        { name: 'Update', value: 'update' },
        { name: 'Cancel', value: 'cancel' }
      ]
    }
  },
  watch: {
    type () {
      if (this.type === 'add') {
        this.user = Object.assign({}, this.data)
      }
    },
    'data.access_financials' (val) {
      this.data.access_payout_methods = val
    },
    addUserModal (val) {
      if (val) {
        this.permissions = (this.data.permissions && Object.keys(this.data.permissions).length > 0) ? Object.assign({}, this.data.permissions) : {
          delivery_orders: { base: [], cash_amount: [] },
          return_orders: { base: [], cash_amount: [] },
          financials: { base: [] },
          payout_methods: { base: [] },
          users: { base: [] }
        }
        this.email = this.data.email
      }
    }
  },
  methods: {
    updateUser () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.data.merchant = this.$route.params.merchantID
          this.data.permissions = this.permissions

          if (!this.isOnline) this.$emit('addUserModal', false)
          sendRequest(false, false, this, `${this.apiURL}${this.data.uid}/`, 'patch', this.data, true,
            () => {
              this.$vs.notify({
                color:'success',
                title: i18nData[this.$i18n.locale]['Success'],
                text: i18nData[this.$i18n.locale]['User'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
                position: 'top-center'
              })
              this.$emit('addUserModal', false)
              this.$emit('loadData')
            }
          )
        }
      })
    },
    addUser () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.data.merchant = this.$store.state.AppActiveUser.userRole === 'merchant' ? this.merchantId : this.$route.params.merchantID
          this.data.permissions = this.permissions
          this.data.access_payout_methods = this.data.access_financials ? this.data.access_payout_methods : false
          this.data.email = this.$store.state.AppActiveUser.userRole === 'merchant' ? this.email.toLowerCase() : `${this.email.toLowerCase()}@shipblu.com`
          if (!this.isOnline) this.$emit('addUserModal', false)
          
          sendRequest(false, false, this, `api/v1/users/merchants/${this.$store.state.AppActiveUser.userRole === 'merchant' ? `?merchant=${this.merchantId}` : ''}`, 'post', this.data, true,
            () => {
              this.$vs.notify({
                color:'success',
                title:i18nData[this.$i18n.locale]['Success'],
                text:i18nData[this.$i18n.locale]['User'] + i18nData[this.$i18n.locale][' has been created successfully!'],
                position: 'top-center'
              })
              this.$emit('addUserModal', false)
              this.$emit('loadData')
            }
          )
        }
      })
    },
    closeModal () {
      this.$emit('addUserModal', false)
      this.$emit('loadData')
    }
  },
  components: {
    ShipbluPrompt,
    vSelect
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss"
</style>